import React, { Component } from "react";
import { PostData } from "../../../service/postData";
import { sendNotification } from "../../../_notificationSettings/notificationPanel";
import QuickAddNewExpenseItem from "../userExpense/expenseItemMaster";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../config/numberFormat";
import validator from "validator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-modal";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import * as XLSX from "xlsx";

import { Link } from "react-router-dom";
import DownloadBtnExpensePdf from "../Invoices/Expense/DownloadBtnExpensePdf";
import PrintBtnExpensePdf from "../Invoices/Expense/PrintBtnExpensePdf";

let _signingId = "0";
let _businessId = "0";
let _company_id = "0";
let country_code = "0";
let tax_name = "";

let _countryCode = "IN"; 

let _businessSetting = {};
let _settingType = "showall";
let _UserSession = localStorage.getItem("vs_UserSession");
if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessSetting = _UserSession.businessSetting;
  if (_businessSetting!=undefined || _businessSetting!=null) {
    if (_businessSetting.PrintOriginalDuplicate == 0) {
      _settingType = null;
    }
  }
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _company_id = _companySession.company_id;
  country_code = _companySession.country_code;
  tax_name = _companySession.tax_name;
}
let columns = [];

let columnsPHistory = [
  {
    label: "Date",
    field: "payment_date",
    width: 50,
  },
  {
    label: "Receipt No",
    field: "payment_rec_no",
    width: 150,
  },
  {
    label: "Amount",
    field: "payment_amount",
    width: 100,
  },
];

let _loader = "glb-ldr-prt active";

export default class expenseItemListPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeExpenseItem: "N/A",
      activeExpenseItemId: 0,
      searchInvNo : "",
      activeExpenseItemBalanace: "0",
      activeExpenseItemTotal: "0",

      activeEditItemId: 0,

      filterSearch: true,
      isLoaded: true,
      isTransactionLoading: false,
      modalIsOpen_AC: false,
      modalIsOpen_PayHis: false,
      company_id: _company_id,
      businessId: _businessId,

      expenseItemArray: [],
      expenseItemArrayFilter: [],
      expenseItemArrayTransaction: [],
      paymentHistoryArray: [],
      paidAmountDuringTrans: 0,
      pageCount : 10,
      page : 1,
      totalCount  : 0,
      pageShow  : 0,
      setPage : 1,
    };
  }

  async componentDidMount() {
    this.getexpenseItemListData();
  }

  getInvoiceSearch = (event) => {
      event.preventDefault();
      const { name, value } = event.target;
      let _valueSend = value;
      this.setState({searchInvNo:_valueSend});
      console.log(this.state.activeExpenseItemId+'==>>=='+_valueSend);
      if(_valueSend.length >= 3 || _valueSend == ''){
          this.getTransactionListData(this.state.activeExpenseItemId,_valueSend,this.state.page,this.state.pageCount);
      }
  }
  getTransactionListData(id,searchInvNo,_page,pageCount) {
    let _transArray = [];
    this.setState({ isTransactionLoading: true });
    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      expenseItem_id: id,
      search_inv_no:searchInvNo,
      pageCount : pageCount,
      page:_page
    });

    PostData(global.userExpenseItemTransactionList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({
            expenseItemArrayTransaction: _transArray,
            isLoaded: true,
            isTransactionLoading: false,
          });
        } else {
          let _activeTotalPrice = 0;
          let _activeBalancePrice = 0;
          if (responseJson.response) {
            _transArray = responseJson.response;
            _transArray.map((trans, i) => {
              _activeTotalPrice =
                parseFloat(_activeTotalPrice) + parseFloat(trans.total_amount);
              _activeBalancePrice =
                parseFloat(_activeBalancePrice) +
                parseFloat(trans.balance_amount);
            });
          }
          _transArray.sort((a, b) => b.added_on - a.added_on);
          this.setState({
            expenseItemArrayTransaction: _transArray,
            isLoaded: true,
            isTransactionLoading: false,
            activeExpenseItemBalanace: _activeBalancePrice,
            activeExpenseItemTotal: _activeTotalPrice,
            totalCount:responseJson.totalCount,pageShow:responseJson.pageShow
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false, isTransactionLoading: false }));
  }

  getexpenseItemListData() {
    let _expenseItemArray = [];
    let _url_GetData =
      global.userexpenseItemList +
      "?company_id=" +
      this.state.company_id +
      "&businessId=" +
      this.state.businessId;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({ isLoaded: true });
        } else {
          let _activeExpenseItem,
            _activeExpenseItemId,
            _activeExpenseItemTotal,
            _activeExpenseItemBalance = "";
          if (responseJson.response) {
            _expenseItemArray = responseJson.response;
            if (responseJson.response) {
              _expenseItemArray = responseJson.response;
              _expenseItemArray.map((exp, i) => {
                if (i == 0) {
                  _expenseItemArray[i].isActiveClick = true;
                  _activeExpenseItem = exp.name;
                  _activeExpenseItemTotal = exp.totalExpenseAmount;
                  _activeExpenseItemBalance = exp.balance;
                  _activeExpenseItemId = exp.item_id;
                } else {
                  _expenseItemArray[i].isActiveClick = false;
                }
              });
            }
          }
          this.setState({
            expenseItemArrayFilter: _expenseItemArray,
            expenseItemArray: _expenseItemArray,
            isLoaded: true,
            activeExpenseItem: _activeExpenseItem,
            activeExpenseItemId: _activeExpenseItemId,
            activeExpenseItemTotal: _activeExpenseItemTotal,
            activeExpenseItemBalanace: _activeExpenseItemBalance,
          });

          if (_activeExpenseItemId > 0) {
            this.getTransactionListData(_activeExpenseItemId,this.state.searchInvNo,this.state.page,this.state.pageCount);
          }
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadexpenseItemListing() {
    let dataList = [];
    let rows = [];

    if (this.state.isLoaded == true) {
      let _partyDetails = this.state.expenseItemArrayFilter;

      if (_partyDetails.length > 0) {
        _partyDetails.map((value, index) => {
          let _activeClass = "simpleRow"; //deactiveRow
          if (this.state.activeExpenseItem == value.name) {
            _activeClass = "activeRow";
          }

          let _deletebtn = (
            <a
              className="dropdown-item"
              href="javascript:void(0)"
              onClick={this.clickToDeleteexpenseItem.bind(
                this,
                value.item_id,
                "Item"
              )}
              style={{ margin: "0px" }}
            >
              Delete
            </a>
          );
          if (value.isTransaction == true) {
            _deletebtn = (
              <a
                className="dropdown-item"
                href="javascript:void(0)"
                onClick={this.clickToDeleteNotifiyExpenseItem.bind(
                  this,
                  value.exp_item_id
                )}
                style={{ margin: "0px" }}
              >
                Delete
              </a>
            );
          }

          dataList.push(
            <tr
              key={index}
              className={_activeClass + " tableRow"}
              onClick={this.clickToActiveRow.bind(
                this,
                value.item_id,
                value.name,
                value.totalExpenseAmount,
                value.balance
              )}
            >
              <td>{value.name}</td>
              <td>{numberFormat(value.totalExpenseAmount)}</td>
              <th className="text-center" scope="row">
                <div className="btn-group show" role="group">
                  <button
                    type="button"
                    id="btnGroupVerticalDrop3"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="fa fa-ellipsis-v"></i>
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu-right min-width-200"
                    aria-labelledby="toolbarDrop"
                    style={{ margin: "0px" }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={this.openModalEditexpenseItemHandler.bind(
                        this,
                        "modalAddexpenseItem",
                        value.item_id
                      )}
                      style={{ margin: "0px" }}
                    >
                      Edit
                    </a>
                    {_deletebtn}
                  </div>
                </div>
              </th>
            </tr>
          );
        });
      }
    }
    return dataList;
  }

  clickToDeleteTransactionNotify(value) {
    confirmAlert({
      title: "Transaction can't be deleted",
      message:
        "Cheque against this transaction has been closed, please reopen it to delete this transaction.",
      buttons: [
        {
          label: "Ok",
        },
      ],
    });
  }
  clickToEditTransactionNotify(value) {
    confirmAlert({
      title: "Transaction can't be edited",
      message:
        "Cheque against this transaction has been closed, please reopen it to edit this transaction.",
      buttons: [
        {
          label: "Ok",
        },
      ],
    });
  }
  
  clickToDeleteNotifiyExpenseItem() {
    confirmAlert({
      title: "Item Alert",
      message:
        "This expense item can not be deleted as it already has transactions. Please delete all transactions other than before deleting the item.",
      buttons: [
        {
          label: "Ok",
        },
      ],
    });
  }

  clickToActiveRow(id, txt, total, balance) {
    this.setState({
      activeExpenseItem: txt,
      activeExpenseItemId: id,
      activeExpenseItemTotal: total,
      activeExpenseItemBalanace: balance,
    });

    if (id > 0) {
      this.getTransactionListData(id,this.state.searchInvNo,this.state.page,this.state.pageCount);
    }
  }

  clickToDeleteexpenseItem(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              expenseItemId: value,
            });
            PostData(global.userExpenseItemDelete, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getexpenseItemListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-dark",
        },
      ],
    });
  }

  clickToDelete(value, type) {
      confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              expanse_id: value.id,
              type_value: "Expense",
            });
            PostData(global.deleteExpenseTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getexpenseItemListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-dark",
        },
      ],
    });
  }

  expensePdf(value) {
    return (
      <>
        <DownloadBtnExpensePdf
          auth={value.id}
          loading={(isLoading) => this.setState({ isPdfLoading: isLoading })}
        />
        <Link
          className="dropdown-item"
          to={"/business/expensePdfDialog/?auth=" + value.id}
          target="_blank"
        >
          Preview
        </Link>
        <PrintBtnExpensePdf
          auth={value.id}
          loading={(isLoading) => this.setState({ isPdfLoading: isLoading })}
        />
      </>
    );
  }

  loadTrasactionListing() {
    let dataList = [];
    let rows = [];
    if (this.state.isLoaded == true) {
      let _transDetails = this.state.expenseItemArrayTransaction;
      if (_transDetails.length > 0) {
        let _i = 0;
        _transDetails.map((value, index) => {
          _i++;

          let _delB = "";
          let _editB = "";
          let _type = "&tType=manage-expense";
          if (value.cheque_status == "1" && value.cheque_status == 1) {
            _delB = (
              <a
                className="dropdown-item"
                href="javascript:void(0)"
                data-id={value.id}
                onClick={this.clickToDeleteTransactionNotify.bind(
                  this,
                  value.id
                )}
              >
                Delete
              </a>
            );

            _editB = (
              <a
                className="dropdown-item"
                href="javascript:void(0)"
                data-id={value.id}
                onClick={this.clickToEditTransactionNotify.bind(this, value.id)}
              >
                View/Edit Details
              </a>
            );
          } else {
            _delB = (
              <a
                className="dropdown-item"
                href="javascript:void(0)"
                data-id={value.id}
                onClick={this.clickToDelete.bind(this, value, "Expense")}
              >
                Delete
              </a>
            );
            _editB = (
              <a
                className="dropdown-item"
                href={
                  global.webUrl +
                  "business/add-expense/?auth=" +
                  value.id +
                  _type
                }
              >
                View/Edit Details
              </a>
            );
          }

          let _actionExtra = (
            <div className="btn-group" role="group">
              <button
                type="button"
                id="btnGroupVerticalDrop3"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-v"></i>
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="btnGroupVerticalDrop1"
              >
                {_editB}
                <a
                  className="dropdown-item"
                  href={
                    global.webUrl +
                    "business/duplicate-expense/?auth=" +
                    value.id+
                    _type
                  }
                >
                  Duplicate
                </a>
                {value.payment_paid!="PAID" && (
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl +
                      "business/expense-make-payment/?auth=" +
                      value.id
                    }
                  >
                    Make Payment
                  </a>
                )}
                <a
                  className="dropdown-item"
                  href="javascript:void(0)"
                  data-id={value.id}
                  onClick={this.expensePaymentHistory.bind(
                    this,
                    value.id,
                    "modalExpensePaymentHistory"
                  )}
                >
                  Payment History
                </a>
                {_delB}
                {/* isChallanPreview={false} */}
                {this.expensePdf(value)}
              </div>
            </div>
          );

          var msDiff = new Date(value.dueDate).getTime() - new Date().getTime(); //Future date - current date
          var daysTill = Math.floor(msDiff / (1000 * 60 * 60 * 24));

          let _statusType = <span className="badge badge-warning">UNPAID</span>;
          if (value.payment_paid === "PARTIAL") {
            _statusType = (
              <span className="badge badge-info">{value.payment_paid}</span>
            );
          } else if (value.payment_paid === "PAID") {
            _statusType = (
              <span className="badge badge-success">{value.payment_paid}</span>
            );
          }

          if (daysTill < -1) {
            _statusType = <span className="text-danger">Order Overdue </span>;
          }
          if (value.balance_amount <= 0) {
            _statusType = <span className="badge badge-success">Paid</span>;
          }
          let _pageAK = this.state.setPage;
          let _showDupL = (value.trans_duplicate_normal == 'Duplicate') ? ' (Duplicate)' : '';
          rows.push({
            //srNo: _i, //value.srNo,
            srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
            invoice_date: value.invoice_date,
            invoice_no: value.customPrefix + " #" + value.invoice_no + _showDupL,
            party_name: value.party_name,
            payment_type: value.payment_type,
            total_amount: numberFormat(value.total_amount),
            balance_amount: numberFormat(value.balance_amount),
            dueDate: value.dueDate,
            statusType: _statusType,
            actionextra: _actionExtra,
          });
        });
      }
    }

    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  loadPaymentHistoryListing() {
    let dataPaymentList = [];
    let rowPayments = [];
    if (this.state.isLoaded == true) {
      let _paymentHistoryArrayDetails = this.state.paymentHistoryArray;
      if (_paymentHistoryArrayDetails.length > 0) {
        let _i = 0;
        _paymentHistoryArrayDetails.map((value, index) => {
          _i++;

          rowPayments.push({
            payment_date: value.invoice_date,
            payment_rec_no: value.invoice_no + " (" + value.type + ")",
            payment_amount: value.total_amount,
          });
        });
      }
    }

    if (rowPayments) {
      dataPaymentList = {
        columns: columnsPHistory,
        rows: rowPayments,
      };
    }
    return dataPaymentList;
  }

  /*For Modal open close*/
  openModalEditexpenseItemHandler(popId, expenseItemId) {
    if (popId == "modalAddexpenseItem") {
      this.setState({ modalIsOpen_AC: true, activeEditItemId: expenseItemId });
    }
  }

  openModalHandler(popId) {
    if (popId == "modalAddexpenseItem") {
      this.setState({ modalIsOpen_AC: true });
    }
  }
  expensePaymentHistory(transId, popId) {
    if (popId == "modalExpensePaymentHistory") {
      this.setState({ modalIsOpen_PayHis: true, paymentTransId: transId });

      let _paymentHistoryTransArray = [];
      let _paidAmountDuringTrans = 0;
      const requestData = JSON.stringify({
        // Backend expensePaymentHistory filters UserTransaction by
        // business_id/company_id as well; omitting them left the where
        // clause with undefined values, Sequelize barfed and the whole
        // history modal rendered "No matching records found" even when
        // a Make-Payment PAYMENT-OUT was linked to this expense.
        business_id: this.state.businessId,
        company_id: this.state.company_id,
        transaction_id: transId,
      });

      PostData(global.expensePaymentHistory, requestData, "POST")
        .then((result) => {
          let responseJson = result;
          _paidAmountDuringTrans = responseJson.paid_amount;
          if (responseJson.success == false) {
            this.setState({
              paymentHistoryArray: _paymentHistoryTransArray,
              isLoaded: true,
              paidAmountDuringTrans: _paidAmountDuringTrans,
            });
          } else {
            if (responseJson.response) {
              _paymentHistoryTransArray = responseJson.response;
            }
            this.setState({
              paymentHistoryArray: _paymentHistoryTransArray,
              paidAmountDuringTrans: _paidAmountDuringTrans,
            });
          }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
    }
  }

  closeModalHandler = (popId) => {
    if (popId == "modalAddexpenseItem") {
      this.setState({ modalIsOpen_AC: false, activeEditItemId: 0 });
    } else if (popId == "modalExpensePaymentHistory") {
      this.setState({ modalIsOpen_PayHis: false, paymentTransId: 0 });
    }
  };
  /*End Modal open close*/

  /* Callback Function from Child */
  getUpdateResponse = () => {
    // Clear the item's transaction list before refreshing. Without this,
    // a newly-added expense item (with no transactions) briefly showed
    // the previously-active item's transactions until the follow-up
    // fetch completed — and if the fetch returned no rows, the stale
    // list persisted. Same pattern as the bank-list fix.
    this.setState({
      modalIsOpen_AC: false,
      activeEditItemId: 0,
      expenseItemArrayTransaction: [],
      totalCount: 0,
    });
    this.getexpenseItemListData();
  };
  /* End Here */

  /* party Filter Code */
  onPartyFilterName = (e) => {
    const data = this.state.expenseItemArray;
    let _name = e.currentTarget.value;
    const keyword = _name.charAt(0).toUpperCase() + _name.slice(1);
    const filtered = data.filter((entry) =>
      Object.values(entry).some(
        (val) =>
          typeof val == "string" &&
          val.toLowerCase().includes(keyword.toLowerCase())
      )
    );
    this.setState({ expenseItemArrayFilter: filtered });
    this.loadexpenseItemListing();
  };
  /* End party Filter Code */

  setFilterSearch = () => {
    this.setState({ filterSearch: !this.state.filterSearch });
  };
  setFilterSearchCancel = () => {
    this.setState({
      filterSearch: !this.state.filterSearch,
      expenseItemArrayFilter: this.state.expenseItemArray,
    });
    this.loadexpenseItemListing();
  };

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }

    if (_businessSetting.DueDatesPaymentTerms == 1) {
      columns = [
        {
          label: "#",
          field: "srNo",
          width: 20,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "#",
          },
        },
        {
          label: "Date",
          field: "invoice_date",
          width: 50,
        },
        {
          label: "Exp No.",
          field: "invoice_no",
          width: 150,
        },
        {
          label: "Party",
          field: "party_name",
          width: 100,
        },
        {
          label: "Payment Type",
          field: "payment_type",
          width: 100,
        },
        {
          label: "Amount",
          field: "total_amount",
          width: 100,
        },
        {
          label: "Balance",
          field: "balance_amount",
          width: 100,
        },
        {
          label: "Due Date",
          field: "dueDate",
          width: 50,
        },
        {
          label: "Status",
          field: "statusType",
          width: 50,
        },
        {
          label: "",
          field: "actionextra",
          width: 100,
        },
      ];
    }
    if (_businessSetting.DueDatesPaymentTerms == 0) {
      columns = [
        {
          label: "#",
          field: "srNo",
          width: 20,
          attributes: {
            "aria-controls": "DataTable",
            "aria-label": "#",
          },
        },
        {
          label: "Date",
          field: "invoice_date",
          width: 50,
        },
        {
          label: "Exp No.",
          field: "invoice_no",
          width: 150,
        },
        {
          label: "Party",
          field: "party_name",
          width: 100,
        },
        {
          label: "Payment Type",
          field: "payment_type",
          width: 100,
        },
        {
          label: "Amount",
          field: "total_amount",
          width: 100,
        },
        {
          label: "Balance",
          field: "balance_amount",
          width: 100,
        },
        {
          label: "Status",
          field: "statusType",
          width: 50,
        },
        {
          label: "",
          field: "actionextra",
          width: 100,
        },
      ];
    }
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-3">
            <div className="block">
              <div className="block pull-r-l">
                <div className="block-content">
                  {this.state.filterSearch ? (
                    <div className="mb-10">
                      <button
                        type="button"
                        data-toggle="layout"
                        data-action="header_search_on"
                        className="btn btn-sm btn-circle btn-outline-secondary mr-5 mb-5"
                        onClick={this.setFilterSearch}
                      >
                        <i className="fa fa-search"></i>
                      </button>

                      <button
                        type="button"
                        className="btn btn-secondary pull-right"
                        onClick={this.openModalHandler.bind(
                          this,
                          "modalAddexpenseItem"
                        )}
                      >
                        <i className="fa fa-plus mr-5"></i>{" "}
                        <b>Add Expense Item</b>
                      </button>
                    </div>
                  ) : (
                    <div id="page-header-search" className="show mb-10">
                      <div className="content-header content-header-fullrow">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-toggle="layout"
                              data-action="header_search_off"
                              onClick={this.setFilterSearchCancel}
                            >
                              <i className="fa fa-times"></i>
                            </button>
                          </div>
                          <input
                            type="text"
                            onChange={this.onPartyFilterName}
                            className="form-control"
                            placeholder="Search here.."
                            id="page-header-search-input"
                            name="page-header-search-input"
                            autocomplete="off"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ borderBottom: "1px solid #e4e7ed" }}></div>
                <div
                  className="block-content"
                  data-toggle="slimscroll"
                  data-height="600px"
                  data-color="#cccccc"
                  data-opacity="1"
                  data-always-visible="true"
                >
                  <table className="table table-striped table-vcenter">
                    <thead id="sideTable">
                      <tr>
                        <th>Item</th>
                        <th style={{ width: "50px" }}>Amount&nbsp;</th>
                        <th style={{ width: "50px" }}>&nbsp;&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody id="sideTable">
                      {this.loadexpenseItemListing()}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9">
            <div className="block">
              <div className="block-content">
                <div className="row items-push">
                  <div className="col-lg-12">
                    <div>
                      <p className="mb-10" style={{ fontSize: "15px" }}>
                        <b>{this.state.activeExpenseItem}</b>{" "}
                        <i className="si si-pin"></i>
                        <span className="mr-5 mb-5 pull-right">
                          <span>
                            Total :{" "}
                            {numberFormat(this.state.activeExpenseItemTotal)}
                          </span>
                          <br />
                          <span className="pull-right">
                            Balance :{" "}
                            {numberFormat(this.state.activeExpenseItemBalanace)}
                          </span>
                        </span>
                      </p>
                    </div>
                    <div className="col-lg-12" style={{margin : '0 0 10px 0'}}>
                      <div>
                        <input type="text" className="form-control col-6" style={{display:'inline-block'}} placeholder='search expense number (type at least three characters)'onChange={this.getInvoiceSearch}/>
                      </div>
                    </div>

                    <div className="" style={{ position: 'relative', minHeight: '80px' }}>
                      {this.state.isTransactionLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 0' }}>
                          <i className="fa fa-spinner fa-spin" style={{ fontSize: '24px', color: '#4a90d9', marginRight: '10px' }}></i>
                          <span style={{ fontSize: '14px', color: '#666' }}>Loading transactions...</span>
                        </div>
                      ) : (
                        <MDBDataTableV5
                          hover
                          span
                          displayEntries={false}
                          entries={100}
                          pagingTop={false}
                          searchTop={false}
                          searchBottom={false}
                          info={false}
                          barReverse
                          data={this.loadTrasactionListing()}
                        />
                      )}
                    </div>
                    
                    <div style={{ float: "right", marginTop: "-15px" }}>
                      <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Rows per page:</div>
                          </div>
                          <div className="d-flex align-items-center" >
                          <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                  onChange={(event) => {
                                      event.preventDefault();
                                      const { name, value } = event.target;
                                      //this.setState({ pageCount: value, setPage: 1 });
                                      this.setState(prevState => ({
                                              pageCount : value,
                                              setPage : 1,
                                          }),
                                          () => {
                                              this.getTransactionListData(this.state.activeExpenseItemId,this.state.searchInvNo,1,value);
                                          });
                                  }}>
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                          </select>
                          </div>
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                          </div>
                      </div>
                    </div>
                    <div className="block-content">
                        <div style={{ float: "left", marginTop: "-45px" }}>
                        <PaginationControl
                            between={this.state.pageCount}
                            total={this.state.totalCount}
                            limit={this.state.pageCount}
                            changePage={(page) => {
                            this.setState({ setPage: page });
                            this.getTransactionListData(this.state.activeExpenseItemId,this.state.searchInvNo,this.state.page,this.state.pageCount
                            );
                            }}
                            ellipsis={1}
                            activeClass={this.state.setPage}
                            page={this.state.setPage}
                        />
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>

        {/* Modal Party Add Begins */}
        <Modal
          isOpen={this.state.modalIsOpen_AC}
          ariaHideApp={false}
          size="sm"
          aria-labelledby="modal-popout"
          onRequestClose={this.closeModalHandler}
          id="modalAddexpenseItem"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="block block-themed block-transparent mb-0">
                <div className="block-header bg-primary-dark">
                  <h3 className="block-title">
                    Manage New / Edit Expense Item
                  </h3>
                  <div className="block-options">
                    <button
                      type="button"
                      className="btn-block-option"
                      onClick={this.closeModalHandler.bind(
                        this,
                        "modalAddexpenseItem"
                      )}
                    >
                      <i className="si si-close"></i>
                    </button>
                  </div>
                </div>
                <div className="block-content">
                  <div className="block-content">
                    <QuickAddNewExpenseItem
                      callBack={this.getUpdateResponse}
                      expenseItemId={this.state.activeEditItemId}
                      isRedirectTo={"business/manage-expense/"}
                    />
                  </div>
                  <br />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-alt-secondary"
                  onClick={this.closeModalHandler.bind(
                    this,
                    "modalAddexpenseItem"
                  )}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal End Party Add*/}

        {/* Modal Payment History Begins */}
        <Modal
          isOpen={this.state.modalIsOpen_PayHis}
          ariaHideApp={false}
          size="sm"
          aria-labelledby="modal-popout"
          onRequestClose={this.closeModalHandler}
          id="modalExpensePaymentHistory"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="block block-themed block-transparent mb-0">
                <div className="block-header bg-primary-dark">
                  <h3 className="block-title">Payment History</h3>
                  <div className="block-options">
                    <button
                      type="button"
                      className="btn-block-option"
                      onClick={this.closeModalHandler.bind(
                        this,
                        "modalExpensePaymentHistory"
                      )}
                    >
                      <i className="si si-close"></i>
                    </button>
                  </div>
                </div>
                <div className="block-content">
                  <div className="block-content">
                    <h5>
                      Paid During Expense : {this.state.paidAmountDuringTrans}
                    </h5>
                    <h5>Linked With :</h5>

                    <div className="">
                      <MDBDataTableV5
                        hover
                        entriesOptions={[25, 50, 100]}
                        entries={25}
                        pagesAmount={4}
                        span
                        pagingTop
                        searchTop
                        searchBottom={false}
                        barReverse
                        data={this.loadPaymentHistoryListing()}
                      />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-alt-secondary"
                  onClick={this.closeModalHandler.bind(
                    this,
                    "modalExpensePaymentHistory"
                  )}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal End Payment History Add*/}
      </React.Fragment>
    );
  }
}
